import React, { useState, useRef } from 'react';
import './PasswordEntry.css';

const PasswordEntry = ({ onCorrectPassword }) => {
  const [password, setPassword] = useState(['', '', '', '', '']);
  const inputRefs = useRef([]);
  const correctPassword = '32323';

  const handleChange = (value, index) => {
    if (value.length > 1) return; // Restrict to single characters
    const newPassword = [...password];
    newPassword[index] = value;
    setPassword(newPassword);

    // Move focus to the next input box
    if (value && index < password.length - 1) {
      inputRefs.current[index + 1].focus();
    }

    // Check if the password is complete
    if (newPassword.every((digit) => digit !== '')) {
      if (newPassword.join('') === correctPassword) {
        onCorrectPassword();
      } else {
        resetPassword();
      }
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace' && password[index] === '' && index > 0) {
      const newPassword = [...password];
      newPassword[index - 1] = '';
      setPassword(newPassword);
      inputRefs.current[index - 1].focus();
    }
  };

  const handleClick = () => {
    inputRefs.current[0]?.focus();
    document.querySelector('.password-entry-container').scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  const resetPassword = () => {
    setPassword(['', '', '', '', '']);
    inputRefs.current[0]?.focus();
  };

  return (
    <div
      className="password-entry-container"
      style={{
        backgroundImage: `url('/static/WorkFlow/password_backgroud.jpg')`,
      }}
      onClick={handleClick}
    >
      <div className="overlay">
        {[0, 1, 2, 3].map((squareIndex) => (
          <div
            key={squareIndex}
            className={`overlay-square square-${squareIndex} ${
              password[squareIndex] ? 'fade-out' : ''
            }`}
          ></div>
        ))}
      </div>

      <div className="password-input-wrapper">
        {password.map((_, index) => (
          <input
            key={index}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={password[index]}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(el) => (inputRefs.current[index] = el)}
            className="password-input"
            maxLength={1}
          />
        ))}
      </div>
    </div>
  );
};

export default PasswordEntry;
